const BASE_PATHS = {
  dev: 'http://localhost:3000',
  stg: 'https://stg.fcpadel.cat',
  pro: 'https://fcpadel.cat'
}

const BASE_PATH = BASE_PATHS[process.env.NEXT_PUBLIC_STAGE]

const STRAPI_PATH = 'https://admin.fcpadel.cat/api'

const STRAPI = {
  MENU: `${STRAPI_PATH}/menus/1?nested&populate=*`,
  PAGE_HOME: `${STRAPI_PATH}/home?populate=deep`,
  GALLERY: `${STRAPI_PATH}/galleries?filters[slug][$contains]={slug}&populate=deep`,
  GALLERY_LIST: `${STRAPI_PATH}/galleries`,
  PAGE: `${STRAPI_PATH}/paginas?filters[base][link][$eq]={link}&populate=deep`,
  NEWS: `${STRAPI_PATH}/noticias/?filters[slug][$eq]={slug}&populate=deep`,
  NEWS_CAT: `${STRAPI_PATH}/noticias/?filters[categoria][$eq]={cat}&populate=deep&pagination[pageSize]=1&sort[0]=fecha%3Adesc`,
  NEWS_LIST: `${STRAPI_PATH}/noticias/?populate=deep&fields[0]=titulo&fields[1]=createdAt&fields[2]=fecha&fields[3]=slug&fields[4]=posicion&sort[0]=fecha%3Adesc`,
  SPONSORS: `${STRAPI_PATH}/patrocinadores/?populate=deep`
}

// ONE as Iberowan
const ONE_PATHS = {
  dev: 'https://devapifcp.iberowan.com/api',
  stg: 'https://devapifcp.iberowan.com/api',
  pro: 'https://apifcp.iberowan.com/api'
}

const ONE_PATH = ONE_PATHS[process.env.NEXT_PUBLIC_STAGE]
const ONE_KEY = '0becf2b4f38d'

const ONE = {
  TOR_LIST: `${ONE_PATH}/torneo/list`,
  TOR_INFO: `${ONE_PATH}/torneo/info/{year}/{slug}`,
  TOR_DRAWS_FILTERS: `${ONE_PATH}/torneo/cuadros/{id}`,
  TOR_DRAWS: `${ONE_PATH}/torneo/partidosCuadro/{id}`,
  TOR_DRAWS_GROUPS: `${ONE_PATH}/torneo/partidosGrupo/{id}`,
  TOR_DRAWS_GROUPS_TABLE: `${ONE_PATH}/torneo/grupoClasificacion/{id}`,
  TOR_DATES: `${ONE_PATH}/torneo/dates/{id}`,
  TOR_FILTERS: `${ONE_PATH}/torneo/ini`,
  TEAM_RESULTS: `${ONE_PATH}/torneo/resultMatchTeam/{id}`,
  CLUBS_LIST: `${ONE_PATH}/club/list`,
  CLUBS_LOCALITIES: `${ONE_PATH}/club/localities`,
  GALLERY: `${ONE_PATH}/media/detail/{slug}`,
  MEDIA_LIST: `${ONE_PATH}/media/list`,
  RANKING_LIST: `${ONE_PATH}/ranking/listGroup`,
  RANKING: `${ONE_PATH}/ranking/detailGroup`,
  REGISTRATION: `${ONE_PATH}/torneo/inscritos/{id}`,
  FIND_LICENSE: `${ONE_PATH}/federado/findLicense/0`,
  COACH_LIST: `${ONE_PATH}/torneo/coachList/{id}`,
  COACH_REGISTRATION: `${ONE_PATH}/federado/coachRegistration/{id}`,
  COACH_PLAYERS: `${ONE_PATH}/federado/coachRegisteredPlayers/{id}`,
  COACH_DELETE_PLAYERS: `${ONE_PATH}/federado/deleteCoachRegisteredPlayers/{id}`,
  PRIVATE_LOGIN: `${ONE_PATH}/federado/login?usuario={user}`,
  PRIVATE_CLUB_LOGIN: `${ONE_PATH}/club/login?usuario={user}`,
  PRIVATE_DATA: `${ONE_PATH}/federado/basicData/{id}`,
  PRIVATE_NEW_FILTERS: `${ONE_PATH}/federado/addNew/0`,
  PRIVATE_RENEW_FILTERS: `${ONE_PATH}/federado/licenses/{id}`,
  PRIVATE_SANCTIONS: `${ONE_PATH}/federado/sanctions/{id}`,
  PRIVATE_WALLET: `${ONE_PATH}/federado/wallet/{id}`,
  PRIVATE_VIRTUAL: `${ONE_PATH}/federado/virtualLicense/{id}/{action}`,
  PRIVATE_ACCESS_REQUEST: `${ONE_PATH}/federado/accessRequest/{id}`,
  PRIVATE_RANKING_GROUP: `${ONE_PATH}/federado/ranking/{id}`,
  PRIVATE_RANKING: `${ONE_PATH}/federado/rankingDetail/{id}`,
  PRIVATE_RANKING_BEST: `${ONE_PATH}/federado/rankingBest/{id}`,
  PRIVATE_RANKING_ALL: `${ONE_PATH}/federado/rankingAllTournaments/{id}`,
  PRIVATE_LEAGUES_ALL: `${ONE_PATH}/federado/rankingAllLeague/{id}`,
  PRIVATE_TOR_REGISTRATION: `${ONE_PATH}/federado/tournamentRegistration/{id}`,
  PRIVATE_TOR_DELETE: `${ONE_PATH}/federado/deleteRegistrationTournament/{id}`,
  PRIVATE_TOR_VALIDATION: `${ONE_PATH}/federado/tournamentValidateLicense/{id}`,
  PRIVATE_MY_TORS: `${ONE_PATH}/federado/registeredTournaments/{id}`,
  PRIVATE_OPEN_TORS: `${ONE_PATH}/federado/availableTournaments/{id}`,
  PRIVATE_TOR_PAYMENT: `${ONE_PATH}/federado/payTournament/{id}`,
  PRIVATE_CHANGE_PASS: `${ONE_PATH}/federado/changePassword/{id}`,
  PRIVATE_CAPTAIN_CHECK_FED: `${ONE_PATH}/federado/validateTeamPlayer/{id}`,
  PRIVATE_CAPTAIN_SAVE_TEAM: `${ONE_PATH}/federado/saveTeamPlayer/{id}`,
  PRIVATE_CAPTAIN_TOR_LINEUP: `${ONE_PATH}/federado/alignmentTournament/{id}`,
  PRIVATE_CAPTAIN_TOR_LINEUP_SAVE: `${ONE_PATH}/federado/saveAlignmentTournament/{id}`,
  PRIVATE_CAPTAIN_TOR_MANAGEMENT: `${ONE_PATH}/federado/teamTournament/{id}`,
  PRIVATE_CAPTAIN_TOR_CHECK_FED: `${ONE_PATH}/federado/validateTeamPlayerTournament/{id}`,
  PRIVATE_CAPTAIN_TOR_SAVE_TEAM: `${ONE_PATH}/federado/saveTeamPlayerTournament/{id}`,
  FCP_DYNAMIC_DATA: `${ONE_PATH}/web/basicData`,

  LEAGUES_FILTERS: `${ONE_PATH}/league/ini/{id}`,
  LEAGUES_RESULTS: `${ONE_PATH}/league/results/{id}/{day}`,
  LEAGUES_CALENDAR: `${ONE_PATH}/league/gameSchedule/{id}`,
  LEAGUES_MATCH: `${ONE_PATH}/league/matchRecord/{id}`,
  LEAGUES_CLASSIFICATION: `${ONE_PATH}/league/classification/{id}`,
  LEAGUES_TEAM: `${ONE_PATH}/league/team/{id}`,
  LEAGUES_TEAM_CAPTAIN: `${ONE_PATH}/league/teamByCaptain/{id}`,
  LEAGUES_TEAM_DELETE: `${ONE_PATH}/league/deleteTeamPlayer/{id}`,
  LEAGUES_TEAM_DELETE: `${ONE_PATH}/league/deleteTeamPlayer/{id}`,
  LEAGUES_CALENDAR_AND_STATUS: `${ONE_PATH}/federado/alignmentCalendar/{id}`,
  LEAGUES_LINEUPS: `${ONE_PATH}/federado/alignmentLeague/{id}`,
  LEAGUES_UPDATE_LINEUPS: `${ONE_PATH}/federado/saveAlignmentLeague/{id}`,
  LEAGUES_ACTS: `${ONE_PATH}/federado/resultLeague/{id}`,
  LEAGUES_DATE_CHANGE: `${ONE_PATH}/federado/matchDateChange/{id}`,
  LEAGUES_TOURNAMENT_BY_CAPTAIN: `${ONE_PATH}/federado/tournamentTeamByCaptain/{id}`,
  LEAGUES_CALENDAR_TOURNAMENT: `${ONE_PATH}/federado/alignmentCalendarTournament/{id}`,

  PRIVATE_CLUB_DATA: `${ONE_PATH}/club/basicData/{id}`,
  PRIVATE_CLUB_LIC_INIT: `${ONE_PATH}/club/licensesIni/{id}`,
  PRIVATE_CLUB_LIC_RENEW: `${ONE_PATH}/club/licensesRenew/{id}`,
  PRIVATE_CLUB_LIC_PROCESS: `${ONE_PATH}/club/licensesProcess/{id}`,
  PRIVATE_CLUB_LIC_REMOVE: `${ONE_PATH}/club/licensesProcessDelete/{id}`,
  PRIVATE_CLUB_ATTACHMENTS: `${ONE_PATH}/club/attachments/{id}`,
  PRIVATE_CLUB_ACCOUNTING: `${ONE_PATH}/club/accounting/{id}`,
  PRIVATE_CLUB_LIC_NEW: `${ONE_PATH}/club/licenseAddNew/{id}`,
  PRIVATE_CLUB_TEAM_RESULTS: `${ONE_PATH}/club/licenseTeamResult/{id}`,
  PRIVATE_CLUB_LIC_TEAMS: `${ONE_PATH}/club/licenseTeams/{id}`,
  PRIVATE_CLUB_LIC_RANKING_ALL: `${ONE_PATH}/club/licenseRankingAllTournaments/{id}`,
  PRIVATE_CLUB_LIC_RANKING_BEST: `${ONE_PATH}/club/licenseRankingBest/{id}`,
  PRIVATE_CLUB_LIC_RANKING: `${ONE_PATH}/club/licenseRanking/{id}`,
  PRIVATE_CLUB_LIC_RANKING_INFO: `${ONE_PATH}/club/licenseRankingDetail/{id}`,
  PRIVATE_CLUB_LIC_DATA: `${ONE_PATH}/club/licenseBasicData/{id}`,
  PRIVATE_CLUB_LICS: `${ONE_PATH}/club/licenses/{id}`,
  PRIVATE_CLUB_BILLS: `${ONE_PATH}/club/bills/{id}`,
  PRIVATE_CLUB_CONTACTS_ACTIONS: `${ONE_PATH}/club/contactsAction/{id}`,
  PRIVATE_CLUB_DETAILS: `${ONE_PATH}/club/detail/{id}`,
  PRIVATE_CLUB_LOCALITIES: `${ONE_PATH}/club/localities`,
  PRIVATE_CLUB_LIST: `${ONE_PATH}/club/list`,
  PRIVATE_CLUB_CAPTAIN_LIST: `${ONE_PATH}/club/captainList/{id}`,
  PRIVATE_CLUB_TORS_AVAILABLE: `${ONE_PATH}/club/requestTeam/{id}`,
  PRIVATE_CLUB_ADD_TEAM_LEAGUE_FILTERS: `${ONE_PATH}/club/addTeamLeague/{id}`,
  PRIVATE_CLUB_TEAMS_LIST: `${ONE_PATH}/club/teams/{id}`,
  PRIVATE_CLUB_TEAM_EDIT: `${ONE_PATH}/club/modifyTeam/{id}`,
  PRIVATE_CLUB_TEAM_ADDRESS: `${ONE_PATH}/club/clubAddress/{id}`,
  PRIVATE_CLUB_TEAM_LAST_YEAR: `${ONE_PATH}/club/teamsAvailableDuplicate/{id}`,
  PRIVATE_CLUB_ADD_TEAM_LAST_YEAR: `${ONE_PATH}/club/addDuplicateTeamsLeague/{id}`,
  PRIVATE_CLUB_PAYMENT_TEAMS: `${ONE_PATH}/club/paymentTeams/{id}`,
  PRIVATE_CLUB_GET_PRICES: `${ONE_PATH}/club/getPricesTeams/{id}`,
  PRIVATE_CLUB_DATE_CHANGE: `${ONE_PATH}/club/matchDateChange/{id}`,
  PRIVATE_CLUB_CALENDAR_AND_STATUS: `${ONE_PATH}/club/alignmentCalendar/{id}`,
  PRIVATE_CLUB_LINEUPS: `${ONE_PATH}/club/alignmentLeague/{id}`,
  PRIVATE_CLUB_ACTS: `${ONE_PATH}/club/resultLeague/{id}`,
  PRIVATE_CLUB_UPDATE_LINEUPS: `${ONE_PATH}/club/saveAlignmentLeague/{id}`,
  PRIVATE_CLUB_TEAM_STATS: `${ONE_PATH}/club/teamsStats/{id}`,
  PRIVATE_CLUB_DELETE_TEAM: `${ONE_PATH}/club/deleteTeamsLeague/{id}`,
  PRIVATE_CLUB_DOCUMENTS_FCP: `${ONE_PATH}/club/documents/{id}`,
  LEAGUES_CLUB_TEAM: `${ONE_PATH}/club/team/{id}`,
  LEAGUES_CLUB_TEAM_AVAILABLE: `${ONE_PATH}/club/teamAvailablePlayers/{id}`,
  PRIVATE_CLUB_SAVE_TEAM: `${ONE_PATH}/club/saveTeamPlayer/{id}`,
  CLUB_FIND_NAME: `${ONE_PATH}/club/licenseName/{id}`,
  CLUB_MEMBERSHIP: `${ONE_PATH}/club/clubMembership/{id}`,
  CLUB_LICENSES_EXCEL: `${ONE_PATH}/club/licensesSummaryExcel/{id}`,

  HEADERS: {
    headers: {
      apikey: ONE_KEY,
      'Content-Type': 'application/json'
    }
  }
}

const FCP_CHANNEL_ID = 'UCAKn_HFjEyDX8uTSgkgSj3A'
const FCP_YT_KEY = 'AIzaSyDxmbkB9SYbqad98BsoOeu7cN2VBQWIJr4'

const OTHERS = {
  YT_LIST: `https://www.googleapis.com/youtube/v3/search?key=${FCP_YT_KEY}&channelId=${FCP_CHANNEL_ID}&pageToken={pageToken}&part=id&order=date&maxResults=48`,
  YT_LIST_STREAMING: `https://www.googleapis.com/youtube/v3/search?key=${FCP_YT_KEY}&channelId=${FCP_CHANNEL_ID}&eventType=completed&type=video&pageToken={pageToken}&part=id&order=date&maxResults=48`
}

export { BASE_PATH, STRAPI, ONE, OTHERS }
